module.exports = __webpack_public_path__ + "img/copy.046922f2.svg";